import React, { FC, Fragment, memo, useCallback, useContext, useState } from 'react'
import { Footer, ScreenContext, Sidebar } from 'react-components'
import { AnyStyledComponent } from 'styled-components'

import {
    Container,
    FooterWrapper,
    GridContainer,
    IconContainer,
    IconContent,
    IconImage,
    IconLi,
    IconUl,
    Image,
    ImageWrapper,
    InnerContainerWrapper,
    LogoImage,
    LogoImagePic,
    MenuWrapper,
    FooterButton,
} from './styles'
import { useTranslation } from '../../../hooks/locale'
import ExternalLink from '../external-link'
import FooterLinksContent from './footer-links-content'

import CloseRegularIcon from '../../../assets/icons/close-regular.svg'
import FooterSectionTransport from '../../../transports/common/footer-section-transport'
import ButtonTransport from '../../../transports/common/button-transport'

interface Props {
    footerSection: FooterSectionTransport
    footerLogo: ButtonTransport
    socialMediaLinks: ButtonTransport[]
}

const FooterSection: FC<Props> = ({ footerSection: { footerGroups }, footerLogo, socialMediaLinks }) => {
    const [visible, setVisible] = useState(false)
    const toggleSidebar = useCallback(() => {
        setVisible(prevVisible => !prevVisible)
    }, [])

    const { isMobile } = useContext(ScreenContext)
    const { t } = useTranslation()

    return (
        <Footer id="footer">
            <FooterWrapper>
                <InnerContainerWrapper>
                    <MenuWrapper isSidebarOpen={visible}>
                        <FooterLinksContent footerGroups={footerGroups} />
                    </MenuWrapper>
                    <GridContainer>
                        <Container>
                            <ImageWrapper>
                                {!!footerLogo.image && (
                                    <LogoImage href={footerLogo.url}>
                                        <LogoImagePic src={footerLogo.image.url} alt={footerLogo.text} />
                                    </LogoImage>
                                )}
                            </ImageWrapper>
                            <IconContainer>
                                <IconUl>
                                    {socialMediaLinks.map(socialMediaLink => (
                                        <IconLi key={socialMediaLink.text}>
                                            <ExternalLink
                                                as={IconContent}
                                                href={socialMediaLink.url}
                                                noCrawl={socialMediaLink.noCrawl}
                                            >
                                                <Image
                                                    src={socialMediaLink.image?.url}
                                                    alt={socialMediaLink.image?.alt}
                                                />
                                            </ExternalLink>
                                        </IconLi>
                                    ))}
                                </IconUl>
                            </IconContainer>
                            <Fragment>
                                {isMobile && (
                                    <FooterButton onClick={toggleSidebar}>
                                        {t('Kontakt, Impressum & mehr')}
                                    </FooterButton>
                                )}
                                {isMobile && visible && (
                                    <Sidebar
                                        visible={visible}
                                        toggleSidebar={toggleSidebar}
                                        menuIcon={''}
                                        topText={t('footerMenu')}
                                        closeIcon={<IconImage as={CloseRegularIcon as AnyStyledComponent} />}
                                    ></Sidebar>
                                )}
                            </Fragment>
                        </Container>
                    </GridContainer>
                </InnerContainerWrapper>
            </FooterWrapper>
        </Footer>
    )
}

export default memo(FooterSection)
